import React from "react";
import { Box, Typography } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoIcon from "@mui/icons-material/Info";

interface AutoUpdateIndicatorProps {
  isAutoUpdating: boolean;
}

const AutoUpdateIndicator: React.FC<AutoUpdateIndicatorProps> = ({
  isAutoUpdating,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      {isAutoUpdating ? (
        <>
          <RefreshIcon
            sx={{
              fontSize: 20,
              color: "success.main",
              animation: "spin 1s linear infinite",
              "@keyframes spin": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.85rem",
              fontWeight: 600,
              color: "success.main",
            }}
          >
            Data updated successfully
          </Typography>
        </>
      ) : (
        <>
          <InfoIcon sx={{ fontSize: 20, color: "info.main" }} />
          <Typography
            variant="body2"
            sx={{
              fontSize: "0.85rem",
              fontWeight: 500,
              color: "info.main",
            }}
          >
            Data refreshes every minute.
          </Typography>
        </>
      )}
    </Box>
  );
};

export default AutoUpdateIndicator;
